import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Spin,
  DatePicker,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
  useEffect,
} from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import CustomUploadNewBank from "@/hocComponents/customUploadNewBank";
const BalanceModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [, setStatementFiles] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [initLoading, setInitLoading] = useState(false);
  const [, setAllFilesState] = useState([]);
  const [, setPreviewIndex] = useState(-1);
  const initialServerFileUidsRef = useRef(new Set());
  const { open, record, statementTime, onClose, onSuccess } = props;
  const [filePaths, setFilePaths] = useState([]);
  const uploadRef = useRef(null);
  const syncFileList = (files = []) => {
    setFilePaths(files);
  };

  useEffect(() => {
    setStatementFiles(filePaths);
    setAllFilesState(filePaths);
    setPreviewIndex(filePaths.length ? 0 : -1);
    form.setFieldsValue({
      fileList: filePaths,
    });
  }, [filePaths, form]);

  useEffect(() => {
    if (!open) return;

    const init = async () => {
      setInitLoading(true);
      try {
        console.log(record);
        form.resetFields();

        setStatementFiles([]);
        setAllFilesState([]);
        setFilePaths([]);
        setPreviewIndex(-1);
        initialServerFileUidsRef.current = new Set();

        form.setFieldsValue({
          balance: record?.balance,
          statementTime: record?.nextStatementDate,
        });

        if (record?.bankId) {
          const files = await loadAllBankFiles(record.bankId);
          const statementList = files.bankStatement || [];
          const all = [...statementList];
          syncFileList(all);
          initialServerFileUidsRef.current = new Set(
            all.map((item) => item?.uid).filter(Boolean),
          );
          setTimeout(() => {
            if (files.length > 0) {
              uploadRef.current?.initUpdateList(files);
            }
          }, 0);
        }
      } finally {
        setInitLoading(false);
      }
    };

    init();
  }, [open, statementTime, record, form]);
  useEffect(() => {
    if (filePaths.length > 0) {
      uploadRef.current?.initUpdateList(filePaths);
    }
  }, [filePaths]);
  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      form.resetFields();
    },
  }));

  const loadAllBankFiles = async (bankId) => {
    if (!bankId) return { bankStatement: [] };

    try {
      const res = await http.get(api.getBankByFile, {
        params: { foreignId: bankId, type: "bankStatement" },
      });

      const mapFiles = (files) =>
        (files || []).map((f) => ({
          id: f.id,
          uid: `bankStatement-${f.id}`,
          type: "bankStatement",
          path: f.path,
          fileName: f.fileDateName || f.fileName,
          name: f.fileDateName || f.fileName,
          status: f.status ?? 0,
          url: f.url,
          allPath: f.url,
          _fromServer: true,
        }));

      return {
        bankStatement: mapFiles(res?.data),
      };
    } catch (e) {
      console.error(e);
      message.error("Failed to load bank files");
      return { bankStatement: [] };
    }
  };

  const uploadByBankApi = async (file, fieldType) => {
    const formData = new FormData();
    formData.append("files", file.originFileObj);
    formData.append("type", fieldType);

    try {
      setUploadLoading(true);
      const res = await http.post(api.getBankUpload, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.code === "1") return res.data[0];
      throw new Error(res.msg || "Upload failed");
    } finally {
      setUploadLoading(false);
    }
  };

  const addOldFn = async (files) => {
    setBtnDisabled(true);
    try {
      const currentFile = files?.[files.length - 1];
      if (!currentFile?.originFileObj) {
        return { flag: false };
      }

      const uploadedFile = await uploadByBankApi(currentFile, "bankStatement");
      const normalizedFile = {
        ...uploadedFile,
        // id: uploadedFile?.id || uploadedFile?.uuid || currentFile.uid,
        uid: uploadedFile?.customId || currentFile.uid,
        type: "bankStatement",
        name:
          uploadedFile?.fileDateName ||
          uploadedFile?.fileName ||
          currentFile.name,
        fileName:
          uploadedFile?.fileDateName ||
          uploadedFile?.fileName ||
          currentFile.name,
        allPath:
          uploadedFile?.url ||
          uploadedFile?.allPath ||
          (currentFile.originFileObj &&
            URL.createObjectURL(currentFile.originFileObj)),
        originFileObj: currentFile.originFileObj,
        size: currentFile.size,
        
      };

      return {
        flag: true,
        fileData: normalizedFile,
      };
    } catch (error) {
      console.error(error);
      message.error(error?.message || "Upload failed");
      return { flag: false };
    } finally {
      setBtnDisabled(false);
    }
  };

  const deleteOldFn = async (file) => {
    let flag = false;
    const response = await http.get(api.getDeleFile, {
      params: { id: file.id || file.uuid },
    });
    if (response.code === "1") {
      flag = true;
    }
    return flag;
  };

  const deleteBase64FileFn = async (file) => {
    const list = filePaths.filter((item) =>
      file?.uuid ? item.uuid !== file.uuid : item.uid !== file.uid,
    );
    return list;
  };

  // 提交
  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const fileList = form.getFieldValue("fileList") || [];
      const initialServerFileUids = initialServerFileUidsRef.current;
      const newFileList = fileList.filter((file) => {
        const uid = file?.uid;
        return !uid || !initialServerFileUids.has(uid);
      });
      const formattedStatementTime = values?.statementTime
        ? dayjs(values.statementTime).format("YYYY-MM-DD")
        : undefined;
      const params = {
        bankId: record?.bankId,
        // bankBalanceNewId: record?.bankBalanceNewId ?? 0,
        balance:
          values?.balance !== undefined && values?.balance !== null
            ? values?.balance
            : undefined,
        statementTime: formattedStatementTime,
        fileList: newFileList.map(({ uid, _fromServer, ...rest }) => rest),
      };

      const res = await http.post(api.getBankUpdateBalance, params);
      if (res?.code === "1") {
        message.success("Balance Created Successfully.");
        onClose?.();
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg);
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            CREATE BANK STATEMENT
          </Typography.Title>
        </Flex>
      }
      width="70%"
      style={{
        maxHeight: "70vh",
      }}
      open={open}
      onCancel={() => {
        onClose?.();
        form.resetFields();
        syncFileList([]);
      }}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              onClose?.();
              form.resetFields();
              syncFileList([]);
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading || uploadLoading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Spin spinning={initLoading}>
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div style={{ marginTop: "20px" }}>
              <Form
                form={form}
                name="createBankForm"
                layout="horizontal"
                labelCol={{ style: { width: "200px" } }}
                wrapperCol={{ style: { flex: 1 } }}
                onFinish={onFinish}
              >
                <Form.Item name="statementTime" hidden />

                <Flex align="flex-start" justify="space-between" gap={32}>
                 <div style={{ flex: '0 0 25%' }}> 
                    <Form.Item
                      name="balance"
                      label="Bank Balance"
                      rules={[
                        {
                          required: true,
                          message: "Please input Bank Balance",
                        },
                      ]}
                    >
                      <Input placeholder="Bank Balance" />
                    </Form.Item>
                    <Form.Item
                      name="statementTime"
                      label="Statement Time"
                      getValueFromEvent={(value) =>
                        value ? value.startOf("day").valueOf() : null
                      }
                      getValueProps={(value) => ({
                        value: value ? dayjs(value) : null,
                      })}
                    >
                      <DatePicker
                        format="YYYY-MM-DD"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </div>

                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        marginBottom: "16px",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      Upload PDF image
                    </div>

                    <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
                      <div>
                        <div className="uploadText">
                          Uploaded files only support JPG, PNG or PDF.
                        </div>

                        <div style={{ marginTop: "20px" }}>
                          <CustomUploadNewBank
                            ref={uploadRef}
                            customConfig={{
                              uploadButtonStyle: {
                                top: "0",
                              },
                              pdfHeight: "62vh",
                              fileFullName: "name",
                              notMultiple: true,
                              accept: ".jpg, .jpeg, .png, .pdf",
                              status: "add",
                              deleteOldFn: deleteOldFn,
                              deleteBase64FileFn: deleteBase64FileFn,
                              addOldFn: addOldFn,
                            }}
                            setFilePaths={syncFileList}
                            filePaths={filePaths}
                            setBtnDisabled={setBtnDisabled}
                            btnDisabled={btnDisabled}
                          />
                        </div>
                      </div>

                      <Form.Item name="fileList" hidden />
                    </Form.Item>
                  </div>
                </Flex>
              </Form>
            </div>
          </div>
        </Flex>
      </Spin>
    </Modal>
  );
});

export default BalanceModal;
